/**
 * Lote crm6 (ficha 29/10, segunda lista do CRM): textos novos do CRM em `pipeline:crm.crm6.*`. Arquivo próprio para a junção
 * dos lotes não brigar com `crm-i18n.ts`.
 */
export const crm6Pt = {
  previa: {
    ver: "Ver {{nome}}",
    novaAba: "Abrir em outra aba",
    baixar: "Baixar",
    falhou: "Não foi possível mostrar este arquivo. Baixe para abrir.",
  },
  arquivos: {
    daNegociacao: "Escolher dos arquivos da negociação",
    titulo: "Arquivos da negociação",
    rotulo: "Marque os arquivos que vão no e-mail",
    anexar: "Anexar",
    cancelar: "Cancelar",
    carregando: "Carregando os arquivos",
    vazio: "A negociação não tem arquivo que possa ir no e-mail.",
    foraDoTipo_one: "{{count}} arquivo não aparece: o e-mail aceita imagem, PDF, Word, Excel, PowerPoint, OpenDocument, TXT ou CSV.",
    foraDoTipo_other: "{{count}} arquivos não aparecem: o e-mail aceita imagem, PDF, Word, Excel, PowerPoint, OpenDocument, TXT ou CSV.",
    daNegociacaoSelo: "da negociação",
    // Lista de 30/10 (B), itens 17 e 19.
    marcar: "Marcar {{nome}}",
    dadosProposta: "Proposta #{{numero}} · {{valor}} · criada em {{data}}",
    propostaSelo: "proposta",
  },
  modelos: {
    pronto: "Pronto",
    usarComoBase: "Usar {{nome}} como base",
    copiaNome: "{{nome}} (cópia)",
    prontoNaLista: "{{nome}} · modelo pronto",
    criarAqui: "Criar modelo",
    editarAqui: "Editar este modelo",
    baseAqui: "Criar a partir deste",
  },
  email: {
    para: "Para",
    paraAjuda: "Um ou mais e-mails. Os da negociação aparecem como sugestão; outro endereço também vale, com aviso antes de enviar.",
    digite: "Digite um e-mail e tecle Enter",
    fora: "fora dos contatos",
    remover: "Remover {{email}}",
    invalido: "{{email}} não é um e-mail válido.",
    demaisNoCampo: "Até {{max}} e-mails neste campo.",
    demais: "Envie para até {{max}} endereços somando Para, CC e CCO.",
    avisoExternos_one: "{{count}} endereço está fora dos contatos da negociação.",
    avisoExternos_other: "{{count}} endereços estão fora dos contatos da negociação.",
    confirmarExternosTitulo: "Enviar para fora dos contatos da negociação?",
    confirmarExternosTexto: "Estes endereços não são do cliente nem das pessoas de contato da negociação: {{lista}}. O envio fica registrado na auditoria.",
  },
};

export const crm6En: typeof crm6Pt = {
  previa: {
    ver: "View {{nome}}",
    novaAba: "Open in a new tab",
    baixar: "Download",
    falhou: "This file could not be shown. Download it to open.",
  },
  arquivos: {
    daNegociacao: "Choose from the deal's files",
    titulo: "Deal files",
    rotulo: "Check the files to send with the email",
    anexar: "Attach",
    cancelar: "Cancel",
    carregando: "Loading the files",
    vazio: "The deal has no file that can go in the email.",
    foraDoTipo_one: "{{count}} file is not shown: the email accepts images, PDF, Word, Excel, PowerPoint, OpenDocument, TXT or CSV.",
    foraDoTipo_other: "{{count}} files are not shown: the email accepts images, PDF, Word, Excel, PowerPoint, OpenDocument, TXT or CSV.",
    daNegociacaoSelo: "from the deal",
    marcar: "Check {{nome}}",
    dadosProposta: "Proposal #{{numero}} · {{valor}} · created on {{data}}",
    propostaSelo: "proposal",
  },
  modelos: {
    pronto: "Ready-made",
    usarComoBase: "Use {{nome}} as a base",
    copiaNome: "{{nome}} (copy)",
    prontoNaLista: "{{nome}} · ready-made template",
    criarAqui: "Create template",
    editarAqui: "Edit this template",
    baseAqui: "Create from this one",
  },
  email: {
    para: "To",
    paraAjuda: "One or more emails. The deal's addresses are suggested; another address also works, with a warning before sending.",
    digite: "Type an email and press Enter",
    fora: "not a deal contact",
    remover: "Remove {{email}}",
    invalido: "{{email}} is not a valid email.",
    demaisNoCampo: "Up to {{max}} emails in this field.",
    demais: "Send to up to {{max}} addresses adding To, CC and BCC.",
    avisoExternos_one: "{{count}} address is not one of the deal's contacts.",
    avisoExternos_other: "{{count}} addresses are not among the deal's contacts.",
    confirmarExternosTitulo: "Send outside the deal's contacts?",
    confirmarExternosTexto: "These addresses are not the customer's or the deal contacts': {{lista}}. The sending is recorded in the audit log.",
  },
};

export const crm6Es: typeof crm6Pt = {
  previa: {
    ver: "Ver {{nome}}",
    novaAba: "Abrir en otra pestaña",
    baixar: "Descargar",
    falhou: "No se pudo mostrar este archivo. Descárgalo para abrirlo.",
  },
  arquivos: {
    daNegociacao: "Elegir de los archivos de la negociación",
    titulo: "Archivos de la negociación",
    rotulo: "Marca los archivos que van en el correo",
    anexar: "Adjuntar",
    cancelar: "Cancelar",
    carregando: "Cargando los archivos",
    vazio: "La negociación no tiene archivos que puedan ir en el correo.",
    foraDoTipo_one: "{{count}} archivo no aparece: el correo acepta imagen, PDF, Word, Excel, PowerPoint, OpenDocument, TXT o CSV.",
    foraDoTipo_other: "{{count}} archivos no aparecen: el correo acepta imagen, PDF, Word, Excel, PowerPoint, OpenDocument, TXT o CSV.",
    daNegociacaoSelo: "de la negociación",
    marcar: "Marcar {{nome}}",
    dadosProposta: "Propuesta #{{numero}} · {{valor}} · creada el {{data}}",
    propostaSelo: "propuesta",
  },
  modelos: {
    pronto: "Lista",
    usarComoBase: "Usar {{nome}} como base",
    copiaNome: "{{nome}} (copia)",
    prontoNaLista: "{{nome}} · plantilla lista",
    criarAqui: "Crear plantilla",
    editarAqui: "Editar esta plantilla",
    baseAqui: "Crear a partir de esta",
  },
  email: {
    para: "Para",
    paraAjuda: "Uno o más correos. Los de la negociación aparecen como sugerencia; otra dirección también vale, con aviso antes de enviar.",
    digite: "Escribe un correo y pulsa Enter",
    fora: "fuera de los contactos",
    remover: "Quitar {{email}}",
    invalido: "{{email}} no es un correo válido.",
    demaisNoCampo: "Hasta {{max}} correos en este campo.",
    demais: "Envía a hasta {{max}} direcciones sumando Para, CC y CCO.",
    avisoExternos_one: "{{count}} dirección está fuera de los contactos de la negociación.",
    avisoExternos_other: "{{count}} direcciones están fuera de los contactos de la negociación.",
    confirmarExternosTitulo: "¿Enviar fuera de los contactos de la negociación?",
    confirmarExternosTexto: "Estas direcciones no son del cliente ni de las personas de contacto de la negociación: {{lista}}. El envío queda registrado en la auditoría.",
  },
};
